import { PaymentVopMatchStatus } from '@alpha/payments-dtos';

const mapVOPStatusToDisplay = (status?: PaymentVopMatchStatus) => {
  switch (status) {
    case PaymentVopMatchStatus.MATCH:
      return 'Full Match';
    case PaymentVopMatchStatus.NO_MATCH:
      return 'No Match';
    case PaymentVopMatchStatus.NEAR_MATCH:
      return 'Close Match';
    case PaymentVopMatchStatus.FAILED:
    case PaymentVopMatchStatus.NOT_AVAILABLE:
      return 'Service Unavailable';
    default:
      return 'Service Unavailable';
  }
};

export default mapVOPStatusToDisplay;
